"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//open layers
require("ol/ol.css");
var ol_1 = require("ol");
var layer_js_1 = require("ol/layer.js");
var Graticule_js_1 = __importDefault(require("ol/Graticule.js"));
var style_js_1 = require("ol/style.js");
var Overlay_js_1 = __importDefault(require("ol/Overlay.js"));
//sources
var OSM_1 = __importDefault(require("ol/source/OSM"));
var XYZ_js_1 = __importDefault(require("ol/source/XYZ.js"));
//general
var proj_js_1 = require("ol/proj.js");
var extent_js_1 = require("ol/extent.js");
var ship_js_1 = __importDefault(require("./../classes/ship.js"));
MapDirective.$inject = ['$http', 'config', 'api', '$interval', '_trip'];
function MapDirective($http, config, api, $interval, _trip) {
    return {
        restrict: 'E',
        template: require('./views/map.html'),
        scope: {
            options: '=',
            message: '='
        },
        link: function (scope, el, attrs, ctrl) {
            scope.ships = null;
            scope.messageFeature = null;
            scope.shipSelected = null;
            // scope.activeShip = null;
            var self = this;
            var refresh_interval = 10000; // 10 seconds
            var refresh_route_interval = 60000; // 1 minute (60000 ms)
            var popup_container = angular.element(el[0].querySelector('#popup'))[0];
            var popup_content = angular.element(el[0].querySelector('#popup-content'))[0];
            var popup_closer = angular.element(el[0].querySelector('#popup-closer'))[0];
            var view = new ol_1.View({
                center: proj_js_1.fromLonLat([15.25, 38.15]),
                zoom: 5,
                minZoom: 5,
                maxZoom: 14,
                projection: 'EPSG:3857',
                enableRotation: false
            });
            var overlay = new Overlay_js_1.default({
                element: popup_container,
                autoPan: true,
                autoPanAnimation: {
                    duration: 250
                }
            });
            var map = new ol_1.Map({
                target: angular.element(el[0].querySelector('.map-core'))[0],
                layers: [],
                overlays: [],
                loadTilesWhileAnimating: false,
                view: view
            });
            var baseLayer = new layer_js_1.Tile({
                preload: 4,
                source: new OSM_1.default({}),
            });
            map.addLayer(baseLayer);
            map.addOverlay(overlay);
            var seaMarks = new layer_js_1.Tile({
                source: new XYZ_js_1.default({
                    url: 'http://t1.openseamap.org/seamark/{z}/{x}/{y}.png',
                })
            });
            map.addLayer(seaMarks);
            //get ships
            var shipLayer = new ship_js_1.default();
            map.addLayer(shipLayer.get());
            api.get('/ships').then(function (ships) {
                scope.ships = ships;
                _.each(ships, function (ship) {
                    ship.feature = shipLayer.addFeature();
                    var data = {
                        id: ship.si,
                        name: ship.name
                    };
                    api.get('/observation/esnah/latest', { si: ship.si }).then(function (info) {
                        if (info) {
                            data.speed = info.speed;
                            data.hdg = info.hdg;
                            data.lon = info.lon;
                            data.lat = info.lat;
                        }
                        api.get('/trips', { count: 1, status: 1, ship: ship.id }).then(function (trips) {
                            ship.trip = trips.data[0];
                            if (ship.trip) {
                                data.dport = ship.trip.dport;
                                data.aport = ship.trip.aport;
                                data.acountry = ship.trip.acountry;
                                data.dcountry = ship.trip.dcountry;
                                data.atime = ship.trip.atime;
                                data.dtime = ship.trip.dtime;
                            }
                            if (info) {
                                ship.feature.setProperties(data);
                                shipLayer.setPosition(ship.feature, proj_js_1.fromLonLat([parseFloat(info.lon), parseFloat(info.lat)]));
                            }
                            if (ship.trip && ship.trip.planned_route_id) {
                                _trip.getPlannedRoute(ship.trip.planned_route_id).then(function (response) {
                                    ship.planned_route = _trip.unpackRoute(response).route;
                                    var points = [];
                                    _.each(ship.planned_route, function (val, idx) {
                                        points.push(proj_js_1.fromLonLat([val.lon, val.lat]));
                                    });
                                    ship.route_feature = shipLayer.drawRoute(points);
                                });
                            }
                        });
                    });
                });
            }, function (error) {
                console.log(error);
            });
            var interval = $interval(function () {
                _.each(scope.ships, function (ship) {
                    api.get('/observation/esnah/latest', { si: ship.si }).then(function (info) {
                        if (info) {
                            var change_overlay = false;
                            if (scope.shipSelected && scope.shipSelected === ship.feature) {
                                change_overlay = true;
                            }
                            var properties = ship.feature.getProperties();
                            properties.speed = info.speed;
                            properties.hdg = info.hdg;
                            properties.lon = info.lon;
                            properties.lat = info.lat;
                            delete properties.geometry;
                            ship.feature.setProperties(properties);
                            shipLayer.setPosition(ship.feature, proj_js_1.fromLonLat([parseFloat(info.lon), parseFloat(info.lat)]));
                            if (change_overlay) {
                                var coordinates = ship.feature.getGeometry().getCoordinates();
                                if (properties.aport && properties.dport) {
                                    popup_content.innerHTML = popup_content.innerHTML = '<div class="name"><span>' + properties.name + '</span></div>' +
                                        '<div class="route"><span class="from">' + properties.dport + ', ' + properties.dcountry + '</span> <i class="material-icons">arrow_right_alt</i> <span class="to">' + properties.aport + ', ' + properties.acountry + '</span></div>' +
                                        '<div class="time"><span class="dtime">' + properties.dtime + '</span><span class="atime">' + properties.atime + '</span></div>' +
                                        '<div class="info"><span class="lon">LON: ' + parseFloat(properties.lon).toFixed(2) + '</span><span class="lat">LAT: ' + parseFloat(properties.lat).toFixed(2) + '</span><span class="sog">HDG: ' + parseFloat(properties.hdg).toFixed(2) + '</span><span class="speed">SPEED: ' + parseFloat(properties.speed).toFixed(2) + '</span></div>';
                                }
                                else {
                                    popup_content.innerHTML = '<div class="name"><span>' + properties.name + '</span></div>' +
                                        '<div class="no-trip-msg">Route not available</div>' +
                                        '<div class="info"><span class="lon">LON: ' + parseFloat(properties.lon).toFixed(2) + '</span><span class="lat">LAT: ' + parseFloat(properties.lat).toFixed(2) + '</span><span class="sog">HDG: ' + parseFloat(properties.hdg).toFixed(2) + '</span><span class="speed">SPEED: ' + parseFloat(properties.speed).toFixed(2) + '</span></div>';
                                }
                                overlay.setPosition(coordinates);
                            }
                        }
                    });
                });
            }, refresh_interval);
            var route_interval = $interval(function () {
                _.each(scope.ships, function (ship) {
                    api.get('/trips', { count: 1, status: 1, ship: ship.id }).then(function (trips) {
                        if (ship.trip && !_.isEmpty(trips.data)) {
                            if (ship.trip.id !== trips.data[0].id) {
                                ship.trip = trips.data[0];
                                if (ship.trip) {
                                    var properties = ship.feature.getProperties();
                                    properties.dport = ship.trip.dport;
                                    properties.aport = ship.trip.aport;
                                    properties.acountry = ship.trip.acountry;
                                    properties.dcountry = ship.trip.dcountry;
                                    properties.atime = ship.trip.atime;
                                    properties.dtime = ship.trip.dtime;
                                    delete properties.geometry;
                                    ship.feature.setProperties(properties);
                                    if (!_.isEmpty(scope.shipSelected) && scope.shipSelected.getProperties().id === ship.si) {
                                        popup_content.innerHTML = popup_content.innerHTML = '<div class="name"><span>' + properties.name + '</span></div>' +
                                            '<div class="route"><span class="from">' + properties.dport + ', ' + properties.dcountry + '</span> <i class="material-icons">arrow_right_alt</i> <span class="to">' + properties.aport + ', ' + properties.acountry + '</span></div>' +
                                            '<div class="time"><span class="dtime">' + properties.dtime + '</span><span class="atime">' + properties.atime + '</span></div>' +
                                            '<div class="info"><span class="lon">LON: ' + parseFloat(properties.lon).toFixed(2) + '</span><span class="lat">LAT: ' + parseFloat(properties.lat).toFixed(2) + '</span><span class="sog">HDG: ' + parseFloat(properties.hdg).toFixed(2) + '</span><span class="speed">SPEED: ' + parseFloat(properties.speed).toFixed(2) + '</span></div>';
                                    }
                                }
                                if (ship.trip.planned_route_id) {
                                    _trip.getPlannedRoute(ship.trip.planned_route_id).then(function (response) {
                                        ship.planned_route = _trip.unpackRoute(response).route;
                                        shipLayer.removeFeature(ship.route_feature);
                                        var points = [];
                                        _.each(ship.planned_route, function (val, idx) {
                                            points.push(proj_js_1.fromLonLat([val.lon, val.lat]));
                                        });
                                        ship.route_feature = shipLayer.drawRoute(points);
                                    });
                                }
                            }
                        }
                        if (_.isEmpty(trips.data) && ship.trip) {
                            var properties = ship.feature.getProperties();
                            properties.dport = null;
                            properties.aport = null;
                            properties.dcountry = null;
                            properties.acountry = null;
                            properties.atime = null;
                            properties.dtime = null;
                            delete properties.geometry;
                            ship.feature.setProperties(null);
                            if (!_.isEmpty(scope.shipSelected) && scope.shipSelected.getProperties().id === ship.si) {
                                popup_content.innerHTML = popup_content.innerHTML = '<div class="name"><span>' + properties.name + '</span></div>' +
                                    '<div class="no-trip-msg">Route not available</div>' +
                                    '<div class="info"><span class="lon">LON: ' + parseFloat(properties.lon).toFixed(2) + '</span><span class="lat">LAT: ' + parseFloat(properties.lat).toFixed(2) + '</span><span class="sog">HDG: ' + parseFloat(properties.hdg).toFixed(2) + '</span><span class="speed">SPEED: ' + parseFloat(properties.speed).toFixed(2) + '</span></div>';
                            }
                            ship.trip = null;
                            ship.feature.setProperties(properties);
                            shipLayer.removeFeature(ship.route_feature);
                        }
                        if (!ship.trip && !_.isEmpty(trips.data)) {
                            ship.trip = trips.data[0];
                            if (ship.trip) {
                                var properties = scope.feature.getProperties();
                                properties.dport = ship.trip.dport;
                                properties.aport = ship.trip.aport;
                                properties.acountry = ship.trip.acountry;
                                properties.dcountry = ship.trip.dcountry;
                                properties.atime = ship.trip.atime;
                                properties.dtime = ship.trip.dtime;
                                delete properties.geometry;
                                if (!_.isEmpty(scope.shipSelected) && scope.shipSelected.getProperties().id === ship.si) {
                                    popup_content.innerHTML = popup_content.innerHTML = '<div class="name"><span>' + properties.name + '</span></div>' +
                                        '<div class="route"><span class="from">' + properties.dport + ', ' + properties.dcountry + '</span> <i class="material-icons">arrow_right_alt</i> <span class="to">' + properties.aport + ', ' + properties.acountry + '</span></div>' +
                                        '<div class="time"><span class="dtime">' + properties.dtime + '</span><span class="atime">' + properties.atime + '</span></div>' +
                                        '<div class="info"><span class="lon">LON: ' + parseFloat(properties.lon).toFixed(2) + '</span><span class="lat">LAT: ' + parseFloat(properties.lat).toFixed(2) + '</span><span class="sog">HDG: ' + parseFloat(properties.hdg).toFixed(2) + '</span><span class="speed">SPEED: ' + parseFloat(properties.speed).toFixed(2) + '</span></div>';
                                }
                                ship.feature.setProperties(properties);
                            }
                            if (ship.trip.planned_route_id) {
                                _trip.getPlannedRoute(ship.trip.planned_route_id).then(function (response) {
                                    ship.planned_route = _trip.unpackRoute(response).route;
                                    var points = [];
                                    _.each(ship.planned_route, function (val, idx) {
                                        points.push(proj_js_1.fromLonLat([val.lon, val.lat]));
                                    });
                                    ship.route_feature = shipLayer.drawRoute(points);
                                });
                            }
                        }
                    });
                });
            }, refresh_route_interval);
            scope.$on('$destroy', function () {
                $interval.cancel(interval);
                $interval.cancel(route_interval);
            });
            // Create the graticule component
            var graticule = new Graticule_js_1.default({
                // the style to use for the lines, optional.
                strokeStyle: new style_js_1.Stroke({
                    color: '#b8b8b8',
                    width: 2,
                    lineDash: [0.5, 4]
                }),
                showLabels: true
            });
            graticule.setMap(map);
            scope.closePopup = function () {
                overlay.setPosition(undefined);
                popup_closer.blur();
                scope.shipSelected = null;
            };
            angular.extend(scope.options, {
                refreshMap: function () {
                    setTimeout(function () { map.updateSize(); }, 300);
                }
            });
            map.on('singleclick', function (evt) {
                if (!_.isEmpty(scope.messageFeature)) {
                    shipLayer.removeFeature(scope.messageFeature);
                    scope.messageFeature = null;
                    _.each(scope.ships, function (ship) {
                        var coordinates = ship.feature.getGeometry().getCoordinates();
                        var data = ship.feature.getProperties();
                        data.type = 'point';
                        delete data.geometry;
                        shipLayer.removeFeature(ship.feature);
                        ship.feature = shipLayer.addFeature();
                        shipLayer.setPosition(ship.feature, coordinates);
                        ship.feature.setProperties(data);
                    });
                    scope.message = {};
                }
                if (overlay.getPosition()) {
                    overlay.setPosition(undefined);
                    popup_closer.blur();
                    scope.shipSelected = null;
                    _.each(scope.ships, function (ship) {
                        if (ship.route_feature) {
                            shipLayer.defaultRouteStyle(ship.route_feature);
                        }
                    });
                }
                else {
                    map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
                        if (feature.getProperties().type === 'point') {
                            scope.shipSelected = feature;
                            var coordinate = feature.getGeometry().getCoordinates();
                            var hdms = proj_js_1.toLonLat(coordinate);
                            var feature_data = feature.getProperties();
                            var ship = _.find(scope.ships, { si: feature_data.id });
                            if (ship) {
                                if (ship.route_feature) {
                                    shipLayer.setRouteStyle(ship.route_feature);
                                }
                            }
                            if (feature_data.aport && feature_data.dport) {
                                popup_content.innerHTML = popup_content.innerHTML = '<div class="name"><span>' + feature_data.name + '</span></div>' +
                                    '<div class="route"><span class="from">' + feature_data.dport + ', ' + feature_data.dcountry + '</span> <i class="material-icons">arrow_right_alt</i> <span class="to">' + feature_data.aport + ', ' + feature_data.acountry + '</span></div>' +
                                    '<div class="time"><span class="dtime">' + feature_data.dtime + '</span><span class="atime">' + feature_data.atime + '</span></div>' +
                                    '<div class="info"><span class="lon">LON: ' + parseFloat(feature_data.lon).toFixed(2) + '</span><span class="lat">LAT: ' + parseFloat(feature_data.lat).toFixed(2) + '</span><span class="sog">HDG: ' + parseFloat(feature_data.hdg).toFixed(2) + '</span><span class="speed">SPEED: ' + parseFloat(feature_data.speed).toFixed(2) + '</span></div>';
                            }
                            else {
                                popup_content.innerHTML = '<div class="name"><span>' + feature_data.name + '</span></div>' +
                                    '<div class="no-trip-msg">Route not available</div>' +
                                    '<div class="info"><span class="lon">LON: ' + parseFloat(feature_data.lon).toFixed(2) + '</span><span class="lat">LAT: ' + parseFloat(feature_data.lat).toFixed(2) + '</span><span class="sog">HDG: ' + parseFloat(feature_data.hdg).toFixed(2) + '</span><span class="speed">SPEED: ' + parseFloat(feature_data.speed).toFixed(2) + '</span></div>';
                            }
                            overlay.setPosition(coordinate);
                        }
                    }, { hitTolerance: 10 });
                }
            });
            scope.$watch('message', function (newval, oldval) {
                if (!_.isEmpty(newval)) {
                    var ship = _.find(scope.ships, { si: newval.si });
                    var coordinates = ship.feature.getGeometry().getCoordinates();
                    var data = ship.feature.getProperties();
                    data.type = 'point_active';
                    delete data.geometry;
                    if (!_.isEmpty(scope.messageFeature)) {
                        shipLayer.removeFeature(scope.messageFeature);
                    }
                    shipLayer.removeFeature(ship.feature);
                    ship.feature = shipLayer.setShipActive();
                    shipLayer.setPosition(ship.feature, coordinates);
                    ship.feature.setProperties(data);
                    scope.messageFeature = shipLayer.setMessageFeature(newval.color);
                    shipLayer.setPosition(scope.messageFeature, proj_js_1.fromLonLat([parseFloat(newval.lon), parseFloat(newval.lat)]));
                    var extent = map.getView().calculateExtent();
                    var feature_extent = scope.messageFeature.getGeometry().getExtent();
                    if (!extent_js_1.containsExtent(extent, feature_extent)) {
                        map.getView().setCenter(proj_js_1.fromLonLat([parseFloat(newval.lon), parseFloat(newval.lat)]));
                    }
                }
            });
        }
    };
}
exports.MapDirective = MapDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/directives/MapDirective.js
// module id = 480
// module chunks = 0